module.exports = __webpack_public_path__ + "img/dsci0079.575e814b.jpg";